import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Container, Row, Col, Card,ListGroup, Button } from "react-bootstrap";
import Program from "../../components/exercice/program";
import { useDispatch, useSelector } from "react-redux";
import { GetWorkoutByUserIdServices } from "../../../core/store/sport/workout/thunk";
import Dialogue from "../../components/exercice/dialogue";
import  "../../../css/workplan.css";

import 'primeicons/primeicons.css'; 

const WorkoutPlanDay = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // États
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedSession, setSelectedSession] = useState(null);
    const [expandedCard, setExpandedCard] = useState(null);

    const [warmUpIndex, setWarmUpIndex] = useState(0);
    const [exerciseIndex, setExerciseIndex] = useState(0);
    const [stretchIndex, setStretchIndex] = useState(0);
    const [dialogue, setDialogue] = useState(false);

    // Récupérer les données depuis Redux
    const workout = useSelector((state) => state.workout.workout);
    const dailyWorkoutPrograms = workout?.dailyWorkoutPrograms || [];

    // Charger les données au montage
    useEffect(() => {
        const authUser = JSON.parse(sessionStorage.getItem('authUser'));
        const userId = authUser?.data?.data?.userId;

        if (!userId) {
            console.error("ID utilisateur non trouvé");
            return;
        }

        dispatch(GetWorkoutByUserIdServices(userId))
            .then((response) => console.log("Réponse du dispatch :", response))
            .catch((error) => console.error("Erreur lors du dispatch :", error));

    }, [dispatch]); // ✅ Ne dépend que de `dispatch`

    // Mettre à jour la session du jour
    useEffect(() => {
        if (dailyWorkoutPrograms.length === 0) return;

        const today = new Date().toISOString().split("T")[0];
        console.log("Date du jour :", today);

        const todaySession = dailyWorkoutPrograms.find(session =>
            session.dateOfDay.startsWith(today)
        )?.workoutSessionsOfDay;

        console.log("Session trouvée dans 'effect :", todaySession);
        setSelectedSession(todaySession || dailyWorkoutPrograms[0]?.workoutSessionsOfDay || null);

    }, [workout]); // ✅ Met à jour la session après chargement du `workout`

    // Changer la session selon la date choisie
    const handleDateChange = (date) => {
        console.log("Date sélectionnée", date);
        setSelectedDate(date);
    
        // Créer un objet Date pour la date sélectionnée et mettre l'heure à minuit
        const normalizedDate = new Date(date);
        normalizedDate.setHours(0, 0, 0, 0);  // Réinitialise l'heure à minuit
    
        const selectedDateString = normalizedDate.toISOString().split("T")[0]; // Format yyyy-mm-dd
        console.log("Date formattée", selectedDateString);
    
        // Trouver la session qui correspond à la date formatée
        const foundSession = dailyWorkoutPrograms.find(session => {
            const sessionDate = new Date(session.dateOfDay);
            sessionDate.setHours(0, 0, 0, 0);  // Réinitialise l'heure de la session
            const sessionDateString = sessionDate.toISOString().split("T")[0];
            return sessionDateString === selectedDateString;
        });
    
        // Mettre à jour l'état avec la session trouvée
        setSelectedSession(foundSession?.workoutSessionsOfDay || null);
    
        console.log("Session trouvée", foundSession);
    };
    
    // Récupération des exercices
    const warmUps = selectedSession?.warmUps?.flatMap(w => w.exercises) || [];
    const exercises = selectedSession?.exercises || [];
    const stretching = selectedSession?.stretching?.flatMap(s => s.exercises) || [];

    const nextItem = (setIndex, list) => setIndex(prev => (prev + 1) % list.length);
    const prevItem = (setIndex, list) => setIndex(prev => (prev - 1 + list.length) % list.length);

    const toggleExpand = (cardId) => {
        setExpandedCard(expandedCard === cardId ? null : cardId); // Toggle entre élargi et normal
    };

    const getAutoplayUrl = (url) => {
        if (!url) return "";
        return url.replace("watch?v=", "embed/") + "?autoplay=1&mute=1"; // Mute pour éviter le blocage
    };

    

    return (
      <>
      <Program/>
            <Row>
                <Col md={2}>
                    <Card >
                        <Card.Body >
                            <Calendar
                                onChange={handleDateChange}
                                value={selectedDate}
                                className="w-100 text-primary"
                            />
                        </Card.Body>
                    </Card>
                </Col>
            
                <Col md={10} >               
                <Card  >
                    <Card.Header className="d-flex justify-content-between align-items-center">
                            <h4>Programme du {selectedDate.toLocaleDateString()}</h4>
                            
                    </Card.Header>


                   
                    <Card.Body style={{ height:  "800px", overflow: "auto",  position: "relative"  }}>
            <Row className="h-200">
                {/* Échauffements */}
                <Col md={4}>
                    <Card  style={{
                                    height: expandedCard === "warmup" ? "830px" : "750px",
                                    width: expandedCard === "warmup" ? "70%" : "auto",
                                    position: expandedCard === "warmup" ? "fixed" : "relative",
                                     top: expandedCard === "warmup" ? "240px" : "auto",
                                      right: expandedCard === "warmup" ? "10px" : "auto",
                                    left: expandedCard === "warmup" ? "710px" : "auto",
                                    // transform: expandedCard === "warmup" ? "translate(-50%, -50%)" : "none",
                                    zIndex: expandedCard === "warmup" ? 9999 : 1, // ✅ Assure que cette carte passe au-dessus
                                    backgroundColor: "black",
                                    border: "1px solid white",
                                    padding: "10px",
                                    boxShadow: expandedCard === "warmup" ? "0px 0px 20px rgba(255, 255, 255, 0.8)" : "none"
                                }}  className="bg-dark text-white cursor-pointer">
                        <Card.Body className="text-center">
                                    <h2 style={{ color: 'greenyellow' }}>Start with Warm-up</h2>
                                    {warmUps.length > 0 ? (
                                        <div>
                                            <h4 className="mt-4 mb-3" style={{color:'white'}}>{warmUps[warmUpIndex].name}</h4>
                                            <iframe 
                                                width="100%"  
                                                height={expandedCard === "warmup" ? "600px" : "300px"} // 🔥 Correction ici
                                                src={getAutoplayUrl(warmUps[warmUpIndex].video)} 
                                                title="WarmUp Video" 
                                                // allow="autoplay" 
                                                style={{ transition: "height 0.3s ease-in-out" }} // 🔥 Ajout d'une animation
                                            ></iframe>

                                            <div>
                                            <Button 
                                            //title="Agrandir ?"
                                            title={expandedCard === "warmup" ? "Réduir ?" : "Agrandir ?"}
                                                variant="light" 
                                                onClick={() => toggleExpand("warmup")}
                                                style={{ background: 'transparent',  border: '1px solid transparent'  }}
                                            >
                                                <i className="bi bi-arrows-angle-expand "  style={{ color: 'white', fontSize: '20px', padding: '5px', border: '1px solid white', borderRadius: '5px'}}></i>
                                            </Button>


                                            </div>
                                            <div style={{top:expandedCard === "warmup" ? "-120px" : "0px"}} className="d-flex justify-content-between mt-3">
                                                <Button variant="light" onClick={() => prevItem(setWarmUpIndex, warmUps)}>  <span style={{ fontSize: '20px' }}>⬅️</span> Previous</Button>
                                                <Button variant="light" onClick={() => nextItem(setWarmUpIndex, warmUps)}>Next  <span style={{ fontSize: '20px' }}>➡️</span></Button>
                                            </div>
                                            <div className="d-flex justify-content-between mt-3">
                                                <p className="text-truncate overflow-hidden text-wrap" style={{ height: "60px" }}>
                                                    {warmUps[warmUpIndex].description}
                                                </p>
                                            </div>
                                        </div>
                                    ) : <p>No warm up planned.</p>}
                                  

                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Exercices */}
                        <Col md={4}>
                            <Card style={{ height :expandedCard === "exercise" ? "830px" : "750px", width: expandedCard === "exercise" ? "1540px" : "auto",
                                            
                                             position: expandedCard === "exercise" ? "absolute" : "relative",
                                             top: expandedCard === "exercise" ? "-50px" : "auto",
                                             left: expandedCard === "exercise" ? "-500px" : "auto",
                                             right: expandedCard === "exercise" ? "500px" : "auto",
                                             zIndex: expandedCard === "exercise" ? 9999 : 1 ,
                                             backgroundColor: "black",
                                             border: "1px solid white",
                                             padding: "10px",
                                             boxShadow: expandedCard === "warmup" ? "0px 0px 20px rgba(255, 255, 255, 0.8)" : "none" }} className="bg-dark text-white cursor-pointer">
                                <Card.Body className="text-center">
                                    <h2 style={{color:'greenyellow'}}>Exercises</h2>
                                    {exercises.length > 0 ? (
                                        <div>
                                            <h4 className="mt-4 mb-3" style={{color:'white'}}>{exercises[exerciseIndex].name}</h4>
                                            <iframe 
                                                width="100%" 
                                                height={expandedCard === "exercise" ? "600px" : "300px"}
                                                src={getAutoplayUrl(exercises[exerciseIndex].video)} 
                                                title="Exercise Video" 
                                               // allow="autoplay" 
                                            ></iframe>
                                            <div>
                                            <Button 
                                           // title="Agrandir ?"
                                            title={expandedCard === "exercise" ? "Réduir ?" : "Agrandir ?"}
                                                variant="light" 
                                                onClick={() => toggleExpand("exercise")}
                                                style={{ background: 'transparent',  border: '1px solid transparent'  }}
                                            >
                                                <i className="bi bi-arrows-angle-expand "  style={{ color: 'white', fontSize: '20px', padding: '5px', border: '1px solid white', borderRadius: '5px'}}></i>
                                            </Button>


                                            </div>
                                            <div style={{top:expandedCard === "exercise" ? "-120px" : "0px"}} className="d-flex justify-content-between mt-3">
                                                <Button variant="light" onClick={() => prevItem(setExerciseIndex, exercises)}> <span style={{ fontSize: '20px' }}>⬅️</span> Previous</Button>
                                                <Button variant="light" onClick={() => nextItem(setExerciseIndex, exercises)}>Next  <span style={{ fontSize: '20px' }}>➡️</span></Button>
                                            </div>
                                            <div className="d-flex justify-content-between mt-3">
                                                <p className="text-truncate overflow-hidden text-wrap" style={{ height: "60px" }}>
                                                    {exercises[exerciseIndex].description}
                                                </p>
                                            </div>
                                        </div>
                                    ) : <p>No exercises planned.</p>}
                                  
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Étirements */}
                        <Col md={4}>
                            <Card style={{ height : expandedCard === "stretching" ? "830px" : "750px",  width: expandedCard === "stretching" ? "1540px" : "auto",
                                          
                                             position: expandedCard === "stretching" ? "absolute" : "relative",
                                             top: expandedCard === "stretching" ? "-50px" : "auto",
                                             left: expandedCard === "stretching" ? "-1000px" : "auto",
                                             zIndex: expandedCard === "stretching" ? 9999 : 1,
                                             backgroundColor: "black",
                                             border: "1px solid white",
                                             padding: "10px",
                                             boxShadow: expandedCard === "warmup" ? "0px 0px 20px rgba(255, 255, 255, 0.8)" : "none"  }} className="bg-dark text-white cursor-pointer">
                                <Card.Body className="text-center">
                                    <h3 style={{color:'greenyellow'}}>Stretching</h3>
                                    {stretching.length > 0 ? (
                                        <div>
                                            <h4 className="mt-4 mb-3" style={{color:'white'}}>{stretching[stretchIndex].name}</h4>
                                            <iframe 
                                                width="100%" 
                                                height={expandedCard === "stretching" ? "600px" : "300px"} 
                                                src={getAutoplayUrl(stretching[stretchIndex].video)} 
                                                title="Stretching Video" 
                                               // allow="autoplay" 
                                            ></iframe>
                                            <div >
                                            <Button 
                                           // title="Agrandir ?"
                                            title={expandedCard === "stretching" ? "Réduir ?" : "Agrandir ?"}//
                                                variant="light" 
                                                onClick={() => toggleExpand("stretching")} 
                                                style={{ background: 'transparent',  border: '1px solid transparent'  }}
                                            >
                                                <i className="bi bi-arrows-angle-expand "  style={{ color: 'white', fontSize: '20px', padding: '5px', border: '1px solid white', borderRadius: '5px'}}></i>
                                            </Button>



                                            </div>



                                            <div style={{top:expandedCard === "stretching" ? "-120px" : "0px"}} className="d-flex justify-content-between mt-3">
                                                <Button variant="light" onClick={() => prevItem(setStretchIndex, stretching)}> <span style={{ fontSize: '20px' }}>⬅️</span> Previous</Button>
                                                <Button variant="light" onClick={() => nextItem(setStretchIndex, stretching)}>Next  <span style={{ fontSize: '20px' }}>➡️</span></Button>
                                            </div>
                                            <div className="d-flex justify-content-between mt-3">
                                                <p className="text-truncate overflow-hidden text-wrap" style={{ height: "60px" }}>
                                                    {stretching[stretchIndex].description}
                                                </p>
                                            </div>
                                        </div>
                                    ) : <p>No stretching planned..</p>}
                                  

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Col>
    </Row>

               
           

        <Dialogue show={dialogue} onHide={() => setDialogue(false)} />

        </>
    );
};

export default WorkoutPlanDay;

// (
//       <>
//       <Program/>
//             <Row>
//                 <Col md={4}>
//                     <Card>
//                         <Card.Body>
//                             <Calendar
//                                 onChange={handleDateChange}
//                                 value={selectedDate}
//                                 className="w-100 text-primary"
//                             />
//                         </Card.Body>
//                     </Card>
//                 </Col>
//                 <Col md={8}>
                
//                     <Card>
//                         <Card.Header className="d-flex justify-content-between align-items-center">
//                             <h4>Programme du {selectedDate.toLocaleDateString()}</h4>
                            
//                         </Card.Header>
//                         <Card.Body>
//                         <Card className="bg-dark text-white cursor-pointer">
                    
//                         <Card.Body>
//                             <Row >
//                                <Col md={6}>
//                                <div className="d-flex align-items-center gap-2">
//                                <h5>Squats</h5>
//                                </div>
//                                </Col>
//                                <Col md={6}>
//                                <h5>Squats</h5>
//                                <p>Squats are a basic exercise that targets the quadriceps, hamstrings, and glutes. They help improve leg strength, balance, and coordination.</p>
//                                </Col>
//                             </Row>
//                         </Card.Body>
//                     </Card>
//                         <Card className="bg-dark text-white cursor-pointer  mt-3">
                    
//                         <Card.Body>
//                             <Row >
//                                <Col md={6}>
//                                <div className="d-flex align-items-center gap-2">
//                                <h5>Squats</h5>
//                                </div>
//                                </Col>
//                                <Col md={6}>
//                                <h5>Squats</h5>
//                                <p>Squats are a basic exercise that targets the quadriceps, hamstrings, and glutes. They help improve leg strength, balance, and coordination.</p>
//                                </Col>
//                             </Row>
//                         </Card.Body>
//                     </Card>
//                             <ListGroup>
//                                 {workoutPlans.map((plan) => (
//                                     <ListGroup.Item 
//                                         key={plan.id} 
//                                         className="mb-3 cursor-pointer hover-bg-primary text-primary" 
//                                         onClick={() => navigate(`/workoutPlanDetail/${plan.id}`)}
//                                     >
//                                         <h5>{plan.name}</h5>
//                                         <ul>
//                                             {plan.exercises.map((exercise, index) => (
//                                                 <li key={index}>{exercise}</li>
//                                             ))}
//                                         </ul>
//                                     </ListGroup.Item>
//                                 ))}
//                             </ListGroup>
//                         </Card.Body>
//                     </Card>
                    
//                 </Col>
//             </Row>

           
        

//         <Dialogue show={dialogue} onHide={() => setDialogue(false)} />





     

//         </>
//     );